export default __webpack_public_path__ + "static/media/UploadImaging.046e4131.svg";